// extracted by mini-css-extract-plugin
module.exports = {"dates":"date-period-tag_dates__yS8FQ"};